import { defineManagePartnersDialogReact } from "./ManagePartnersDialog"

/** @internal */
export function setupPartners(module: ng.IModule) {
    return module.directive("omniaManagePartnersDialog", defineManagePartnersDialogReact)
}
